import { IS_VERCEL, SITE_URL } from "@opensea/utils"
import {
  abstractConnector,
  glyphConnector,
  OPENSEA_LOGO_URL,
  osEmbeddedWalletConnector,
  veeFriendsWalletConnector,
  walletConnectConnector,
} from "@opensea/wallet"
import { baseAccount, metaMask } from "wagmi/connectors"
import { IS_PRODUCTION } from "@/constants/env"

export const getConnectors = () => {
  const connectors = [
    osEmbeddedWalletConnector({
      environment: IS_PRODUCTION || IS_VERCEL ? "production" : "development",
      debug: process.env.NEXT_PUBLIC_DEBUG_MODE === "true",
      clientId: process.env.NEXT_PUBLIC_OPENSEA_WALLET_CLIENT_ID,
    }),
    metaMask({
      dappMetadata: {
        name: "OpenSea",
        url: SITE_URL.href,
        iconUrl: OPENSEA_LOGO_URL,
      },
    }),
    baseAccount({
      appName: "OpenSea",
      appLogoUrl: OPENSEA_LOGO_URL,
    }),
    abstractConnector(),
    veeFriendsWalletConnector(),
    glyphConnector(),
  ]

  if (process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID) {
    connectors.push(
      walletConnectConnector({
        projectId: process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
      }),
    )
  }

  return connectors
}
